import { HttpClient } from '../httpClient';
import DirectorsResponse from '../responses/directorsResponse';
import DirectorResponse from '../responses/directorResponse';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import DirectorRequest from '../requests/directorRequest';
import User from '../models/user';
import District from '../models/district';

const httpClient = new HttpClient();

export const getDirectorById = async (directorId: number) => {
  return httpClient.get<DirectorResponse>({
    url: `/v1/Directors/${directorId}`,
    requiresToken: true,
  });
};

export const getDirectors = async () => {
  return httpClient.get<DataResponse<User[]>>({
    url: `/v1/Directors/`,
    requiresToken: true,
  });
};

export const getDirectorsByDistrictId = async (DistrictId: number) => {
  return httpClient.get<DirectorsResponse>({
    url: `/v1/Directors/ByDistrict/${DistrictId}`,
    requiresToken: true,
  });
};

export const createDirector = async (directorRequest: DirectorRequest) => {
  return httpClient.post<DirectorResponse>({
    url: '/v1/admin/Directors',
    payload: directorRequest,
    requiresToken: true,
  });
};

export const updateDirector = async (
  directorId: number | undefined,
  directorRequest: DirectorRequest
) => {
  return directorId ? httpClient.put<BaseResponse>({
    url: `/v1/admin/Directors/${directorId}`,
    payload: directorRequest,
    requiresToken: true,
  }) : false;
};

export const deleteDirector = async (directorId: number | undefined) => {
  return directorId ? await httpClient.delete<BaseResponse>({
    url: `/v1/admin/Directors/${directorId}`,
    requiresToken: true,
  }) : false;
};

export const getDistrictsByDirectorUserId = async (DirectorUserId: number) => {
  return httpClient.get<DataResponse<District[]>>({
    url: `/v1/Directors/${DirectorUserId}/Districts`,
    requiresToken: true,
  })
}

export const getTherapistsByDirectorUserId = async (DirectorUserId: number) => {
  return httpClient.get<DataResponse<User[]>>({
    url: `/v1/Directors/${DirectorUserId}/Therapists`,
    requiresToken: true,
  })
}